<template>
    <div style="text-align: left;" class="mx-2 mx-md-0">
        <div
          v-if="isMobile"
          class="d-flex justify-content-between align-items-center mb-2 py-2"
        >
          <b-button
            size="sm"
            variant="outline-primary"
            @click="filtersVisible = !filtersVisible"
          >
            <b-icon-funnel-fill class="mr-1" />
            {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
          </b-button>
        </div>

        <b-collapse :visible="!isMobile || filtersVisible" style="width: 100%;">
            <div style="margin-bottom: 5px;">
                <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>SELECT DATE RANGE</div>
                        <b-input
                            id="dates"
                            size="lg"
                            variant="dark"
                            :placeholder="[query.startDate, query.endDate].join(' - ')"
                            style="display: inline-block; width: 220px; font-size: 14px; font-weight: bold;"
                            class="responsive-input"
                            autocomplete="off"
                        ></b-input>
                        <b-button size="sm" variant="dark" @click="search_dates" class="mt-1 mt-md-0">SEARCH</b-button>
                    </div>

                    <div style="display: inline-block; vertical-align: top;" v-if="query.startDate && query.endDate">
                        <div>ORDER TYPE</div>
                        <b-form-select size="lg" :options="order_types" v-model="order_type"
                            style="width: 110px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- TYPE --</b-form-select-option>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <div style="display: inline-block; vertical-align: top;" v-if="query.startDate && query.endDate">
                        <div>ITEM STATUS</div>
                        <b-form-select size="lg" :options="limitedStatusOptions" v-model="state"
                            style="width: 110px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- STATUS --</b-form-select-option>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>

                    <!-- Truck Status Filter -->
                    <div style="display: inline-block; vertical-align: top;" v-if="query.startDate && query.endDate && items.length > 0">
                        <div>TRANSFER STATUS</div>
                        <b-form-select 
                            size="lg" 
                            :options="truckStatusOptions" 
                            v-model="truck_assignment_filter"
                            style="width: 150px; font-size: 14px; font-weight: bold;"
                        >
                        </b-form-select>
                    </div>

                    <!-- Delivery Status Filter -->
                    <div style="display: inline-block; vertical-align: top;" v-if="query.startDate && query.endDate && items.length > 0">
                        <div>DELIVERY STATUS</div>
                        <b-form-select 
                            size="lg" 
                            :options="deliveryStatusOptions" 
                            v-model="delivery_status_filter"
                            style="width: 150px; font-size: 14px; font-weight: bold;"
                        >
                        </b-form-select>
                    </div>
                </b-alert>

                
                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>ITEM LOCATION</div>
                        <b-form-select size="lg" :options="packet.locations" v-model="location_filter"
                            style="width: 180px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- ITEM LOCATION --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-alert>

                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>DROP LOCATION</div>
                        <b-form-select size="lg" :options="packet.locations" v-model="drop_location_filter"
                            style="width: 180px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- DROP LOCATION --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-alert>

                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" v-if="items.length > 0">
                    <div style="display: inline-block; vertical-align: top;">
                        <div>DELIVERY LOCATION</div>
                        <b-form-select size="lg" :options="deliveryLocationOptions" v-model="delivery_location_filter"
                            style="width: 180px; font-size: 14px; font-weight: bold;">
                            <template #first>
                                <b-form-select-option :value="null" disabled>-- DELIVERY LOCATION --</b-form-select-option>
                                <b-form-select-option :value="null">ALL</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-alert>

                <!-- Transfer Truck Filter -->
                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" 
                        v-if="query.startDate && query.endDate && items.length > 0">
                    <div>TRANSFER TRUCK</div>
                    <b-form-select size="lg" :options="trucks" v-model="pick_truck_filter"
                        style="width: 180px; font-size: 14px; font-weight: bold;">
                        <template #first>
                            <b-form-select-option :value="null" disabled>-- SELECT TRUCK --</b-form-select-option>
                            <b-form-select-option :value="null">ALL STATUS</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-alert>

                <!-- Delivery Truck Filter -->
                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" 
                        v-if="query.startDate && query.endDate && items.length > 0">
                    <div>DELIVERY TRUCK</div>
                    <b-form-select size="lg" :options="trucks" v-model="delivery_truck_filter"
                        style="width: 180px; font-size: 14px; font-weight: bold;">
                        <template #first>
                            <b-form-select-option :value="null" disabled>-- SELECT TRUCK --</b-form-select-option>
                            <b-form-select-option :value="null">ALL TRUCKS</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-alert>

                <!-- Combined Product Search Filter -->
                <b-alert variant="info" show style="display: inline-block; vertical-align: top; margin-right: 10px;" 
                        v-if="query.startDate && query.endDate && items.length > 0">
                    <div>SEARCH PRODUCT</div>
                    <b-input
                        size="lg"
                        :placeholder="'SKU or product name'"
                        style="width: 200px; font-size: 14px;"
                        v-model="product_search_filter"
                        @input="applyTextFilters"
                        debounce="300"
                    ></b-input>
                </b-alert>

                <b-alert variant="info" show style="display: inline-block; vertical-align: top; margin-right: 10px;" 
                        v-if="query.startDate && query.endDate && items.length > 0">
                    <div>SEARCH INVOICE</div>
                    <b-input
                        size="lg"
                        :placeholder="'Invoice #'"
                        style="width: 150px; font-size: 14px;"
                        v-model="invoice_number_filter"
                        @input="applyTextFilters"
                        debounce="300"
                    ></b-input>
                </b-alert>

                <b-alert variant="primary" show style="display: inline-block; vertical-align: top;" 
                        v-if="query.startDate && query.endDate && items.length > 0">
                    <div>TRUCK TYPE</div>
                    <b-form-select 
                        size="lg" 
                        :options="truckTypeOptions" 
                        v-model="truck_type_filter"
                        style="width: 180px; font-size: 14px; font-weight: bold;"
                    >
                    </b-form-select>
                </b-alert>

                <!-- Show Same Location Items Toggle -->
                <!-- <b-alert variant="info" show style="display: inline-block; vertical-align: top; margin-left: 5px;" 
                        v-if="query.startDate && query.endDate && items.length > 0">
                    <div>SHOW SAME LOCATION ITEMS</div>
                    <b-button
                        size="sm"
                        variant="outline-info"
                        @click="toggleShowSameLocationItems"
                        style="font-size: 14px;"
                    >
                        {{ showSameLocationItems ? 'Hide' : 'Show' }}
                    </b-button>
                </b-alert> -->

                <!-- Clear Filters Button -->
                <b-alert variant="warning" show style="display: inline-block; vertical-align: top;" 
                        v-if="hasActiveTextFilters">
                    <div>CLEAR FILTERS</div>
                    <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="clearTextFilters"
                        style="font-size: 14px;"
                    >
                        Clear
                    </b-button>
                </b-alert>

                <!-- NEW: Bulk Assignment Buttons -->
                <b-alert variant="info" show style="display: inline-block; vertical-align: top; margin-left: 10px;" 
                        v-if="selectedItems.length > 0">
                    <div>BULK ASSIGN TRUCKS</div>
                    <b-button
                        size="sm"
                        variant="warning"
                        @click="bulkAssignPickupTruck"
                        :disabled="!hasPickupAssignableItems"
                        style="margin-right: 5px;"
                    >
                        <b-icon-truck></b-icon-truck> Assign Pickup Truck
                    </b-button>
                    <b-button
                        size="sm"
                        variant="success"
                        @click="bulkAssignDeliveryTruck"
                        :disabled="!hasDeliveryAssignableItems"
                    >
                        <b-icon-truck></b-icon-truck> Assign Delivery Truck
                    </b-button>
                </b-alert>
            </div>
        </b-collapse>

        <b-card no-body>
            <div style="min-height: 500px; max-height: 1000px; overflow-y: scroll; height: 100%;">
                <div style="border: 1px solid gray; padding: 10px;">
                    <div style="width: 100%; height: 100%;" v-if="items_being_loaded">
                        <loading :active="true" :can-cancel="false" :is-full-page="false">
                        </loading>
                    </div>

                    <div v-else>
                        <div v-if="items.length > 0" style="position: relative; overflow-x: auto;">
                            <div style="display: inline-block; vertical-align: top; margin: 5px;">
                                <h5 style="z-index:100; font-family: courier; font-weight: bold;">
                                    PICKLIST FOR {{ query.startDate }} TO {{ query.endDate }}
                                </h5>
                            </div>

                            <div style="display: inline-block; vertical-align: top; margin: 5px;">
                                <download-csv class="btn" :data="get_csv_data()"
                                    style="border: 1px solid black; width: 180px; background: black; color: white; "
                                    :name="get_csv_filename()">

                                    DOWNLOAD EXCEL

                                </download-csv>
                                <b-button
                                    size="md"
                                    variant="success"
                                    class="ml-2"
                                    :disabled="!showSaveButton"
                                    @click="save_selected_pickup_items"
                                >
                                    {{ saveButtonText }}
                                </b-button>
                            </div>
                            <div v-if="selectedItems.length > 1" style="position: sticky; width:100%; top: 0; background: white; z-index: 100; padding: 5px; border-bottom: 1px solid #ccc;">
                                Assign truck to all selected:
                                <b-form-select
                                    size="sm"
                                    style="width: 150px; display: inline-block; margin-left: 10px;"
                                    :options="trucks"
                                    v-model="commonTruck"
                                    @change="update_selected_trucks_stats()"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null">Select Truck</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>
                            <table style="width: 100%;">
                                <thead>
                                    <tr style="background-color: black; color: white;">
                                        <th class="ipt_tdr"
                                            style="min-width: 30px; text-align: center; background-color: black; color: white;">
                                            <input type="checkbox" v-model="selectAll" @change="toggleSelectAll">
                                        </th>
                                        <th class="ipt_tdr" @click="sortby('invoice_id')"
                                            style="background-color: black; color: white; ">
                                            INVOICE #
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('product_name')"
                                            style="min-width: 200px; background-color: black; color: white;">
                                            PRODUCT NAME
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('product_sku')"
                                            style="background-color: black; color: white;">
                                            PRODUCT SKU
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('order_type')"
                                            style="background-color: black; color: white;">
                                            ORDER TYPE
                                        </th>

                                        <th class="ipt_tdr" style="background-color: black; color: white;">
                                            QTY
                                        </th>

                                        <th class="ipt_tdr" style="background-color: black; color: white;"
                                            @click="sortby('state')">
                                            STATUS
                                        </th>

                                        <th class="ipt_tdr" style="background-color: black; color: white;"
                                            @click="sortby('')">
                                            DELIVERY DATE
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('locsub')"
                                            style="background-color: black; color: white;">
                                            PICK FROM
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('pickup_truck', packet.trucksdict)"
                                            style="background-color: black; color: white;">
                                            TRANSFER TRUCK
                                        </th>

                                        <!-- New Truck Assignment Status Column -->
                                        <th class="ipt_tdr" style="background-color: black; color: white;">
                                            TRANSFER STATUS
                                        </th>

                                        <th class="ipt_tdr" @click="sortby('drop_locsub')"
                                            style="background-color: black; color: white;">
                                            DROP LOCATION
                                        </th>

                                        <!-- DELIVERY TRUCK COLUMN -->
                                        <th class="ipt_tdr" @click="sortby('truck', packet.trucksdict)"
                                            style="background-color: black; color: white;">
                                            DELIVERY TRUCK
                                        </th>

                                        <!-- DELIVERY STATUS COLUMN -->
                                        <th class="ipt_tdr" style="background-color: black; color: white;">
                                            DELIVERY STATUS
                                        </th>

                                        <!-- DELIVERY LOCATION COLUMN -->
                                        <th class="ipt_tdr" @click="sortby('drop_locsub')"
                                            style="background-color: black; color: white;">
                                            DELIVERY LOCATION
                                        </th>

                                        <th class="ipt_tdr" hidden-print style="background-color: black; color: white;">
                                            COMMENTS
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="item, idx in displayItems" v-if="allowed(item)">
                                        <td class="ipt_tdr" style="text-align: center;">
                                            <input
                                                type="checkbox"
                                                v-model="selectedItems"
                                                :value="item"
                                                :disabled="!isSelectable(item)"
                                            >
                                        </td>
                                        <td class="ipt_tdr" style="font-size: 12px;">
                                            {{ getDisplayInvoiceId(item) }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ (item.product_name || item.product_sku) }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ (item.product_sku || '').toUpperCase() }}
                                        </td>

                                        <td class="ipt_tdr"
                                            :style="{ 'background-color': get_order_type_color(item.order_type) }">
                                            {{ getDisplayOrderType(item) }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ item.quantity }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ limitedStatesDict[item.state] || states_dict[item.state] }}
                                        </td>

                                        <td class="ipt_tdr">
                                            {{ item.pull_date }}
                                        </td>

                                        <td class="ipt_tdr">
                                            <b-form-select size="sm" style="font-size: 12px; width: 200px;"
                                                :value="getDisplayLocsub(item)"
                                                @input="updateLocsub(item, $event)"
                                                :disabled="isPickLocationDisabled(item)">
                                                <b-form-select-option
                                                    v-for="locsub, lidx in getAvailableLocsubs(item)"
                                                    :value="locsub.value"
                                                    v-bind:key="lidx"
                                                    :style="isOutOfStock(item, locsub) ? 'color: red; font-style: italic;' : ''"
                                                >
                                                    {{
                                                        all_loc_inventory_dict[concater([item.product_sku, locsub.location_id, locsub.sublocation_id])] || 0
                                                    }}
                                                    -
                                                    {{ locsub.location }} | {{ locsub.sublocation }}
                                                    {{ isOutOfStock(item, locsub) ? '(Out of Stock)' : '' }}
                                                </b-form-select-option>
                                            </b-form-select>
                                        </td>

                                        <td class="ipt_tdr">
                                            <b-form-select 
                                                size="sm" 
                                                style="width: 130px;" 
                                                :options="trucks"
                                                v-model="item.pickup_truck"
                                                :disabled="isDisabled(item) || item.state == 5"
                                                @input="onPickupTruckChange(item)"
                                            >
                                            </b-form-select>
                                        </td>

                                        <!-- New Truck Assignment Status Column Data -->
                                        <td class="ipt_tdr">
                                            <span :class="getTruckStatusClass(item)">
                                                {{ getTruckStatus(item) }}
                                            </span>
                                        </td>

                                        <td class="ipt_tdr">
                                            <b-form-select
                                                v-model="item.ship_locsub"
                                                style="width: 200px; font-size: 11px;"
                                                :disabled="isDisabled(item)"
                                                @input="onShipLocsubChange(item)"
                                            >
                                                <b-form-select-option
                                                    v-for="opt in buildStageLocsubOptions(item)"
                                                    :key="opt.value"
                                                    :value="opt.value"
                                                >
                                                    {{ opt.label }}
                                                </b-form-select-option>
                                            </b-form-select>
                                        </td>

                                        <!-- DELIVERY TRUCK FIELD -->
                                        <td class="ipt_tdr">
                                            <b-form-select 
                                                size="sm" 
                                                style="width: 130px;" 
                                                :options="trucks"
                                                v-model="item.truck"
                                                :disabled="isDeliveryTruckDisabled(item)"
                                                @input="onDeliveryTruckChange(item)"
                                            >
                                                <template v-if="!shouldShowDeliveryTruck(item)">
                                                    <b-form-select-option :value="null" disabled>
                                                        SAME LOCATION - NOT NEEDED
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            
                                            <!-- Optional: Add a tooltip or note -->
                                            <!-- <span v-if="!shouldShowDeliveryTruck(item)" 
                                                  style="font-size: 10px; color: #666; display: block;">
                                                Drop & Delivery locations are same
                                            </span> -->
                                        </td>

                                        <!-- DELIVERY STATUS FIELD -->
                                        <td class="ipt_tdr">
                                            <span :class="getDeliveryStatusClass(item)">
                                                {{ getDeliveryStatus(item) }}
                                            </span>
                                        </td>
                                        
                                        <!-- DELIVERY LOCATION FIELD (Dropdown like other location fields) -->
                                        <td class="ipt_tdr">
                                            <b-form-select
                                                v-model="item.drop_locsub"
                                                style="width: 200px; font-size: 11px;"
                                                :disabled="isDeliveryLocationDisabled(item)"
                                                @input="onDropLocsubChange(item)"
                                            >
                                                <b-form-select-option
                                                    v-for="opt in getDeliveryLocationOptions(item)"
                                                    :key="opt.value"
                                                    :value="opt.value"
                                                >
                                                    {{ opt.label }}
                                                </b-form-select-option>
                                            </b-form-select>
                                        </td>

                                        <td class="ipt_tdr hidden-print">
                                            <span v-if="comments_dict[getCommentKey(item)]">
                                                <button style="border: 1px solid black; color: red; font-weight: bold;"
                                                    @click="show_comments(item)" :disabled="isDisabled(item)">CMNT ({{
                                                        comments_dict[getCommentKey(item)]}})
                                                </button>
                                            </span>
                                            <span v-else>
                                                <button @click="show_comments(item)" :disabled="isDisabled(item)">CMNT
                                                </button>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>

        <!-- NEW: Bulk Assignment Modal -->
        <b-modal id="modal-bulk-assign-truck" size="sm" hide-footer :title="bulkAssignmentTitle">
            <div v-if="bulkAssignmentType === 'pickup'">
                <p>Assign pickup truck to <strong>{{ selectedItems.length }}</strong> selected item(s):</p>
                <b-form-select
                    v-model="bulkSelectedTruck"
                    :options="trucks"
                    size="sm"
                    style="width: 100%; margin-bottom: 15px;"
                >
                    <template #first>
                        <b-form-select-option :value="null">-- Select Pickup Truck --</b-form-select-option>
                    </template>
                </b-form-select>
            </div>
            
            <div v-else-if="bulkAssignmentType === 'delivery'">
                <p>Assign delivery truck to <strong>{{ selectedItems.length }}</strong> selected item(s):</p>
                <b-form-select
                    v-model="bulkSelectedTruck"
                    :options="trucks"
                    size="sm"
                    style="width: 100%; margin-bottom: 15px;"
                >
                    <template #first>
                        <b-form-select-option :value="null">-- Select Delivery Truck --</b-form-select-option>
                    </template>
                </b-form-select>
            </div>
            
            <div class="text-right">
                <b-button
                    size="sm"
                    variant="secondary"
                    @click="$bvModal.hide('modal-bulk-assign-truck')"
                    style="margin-right: 5px;"
                >
                    Cancel
                </b-button>
                <b-button
                    size="sm"
                    :variant="bulkAssignmentType === 'pickup' ? 'warning' : 'success'"
                    @click="confirmBulkAssignment"
                    :disabled="!bulkSelectedTruck"
                >
                    Assign
                </b-button>
            </div>
        </b-modal>

        <b-modal id="modal-comments-process-pickups" scrollable size="md" hide-footer
            :title="'COMMENTS FOR (' + item_comments_invoice_id + ')'">
            <ItemComments
                :viewdata="{ invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username }" />
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Requestor from '@/utilities/Requestor';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ItemComments from '@/components/importables/ItemComments'
import mappings from '@/utilities/mappings'
import { BIconFunnelFill, BIconTruck } from "bootstrap-vue";

export default {
    name: "AdminToolsProcessDeliveries",
    components: { flatPickr, Loading, ItemComments, BIconTruck },
    data: function () {
        return {
            packet: {},
            all_loc_inventory_dict: {},
            states_dict: mappings.states_dict || [],
            limitedStatesDict: {},
            state: null,
            truck_type_filter: 'all',
            items: [],
            originalValues: {},
            filteredItems: [],
            query: {
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD')
            },
            location_filter: null,
            drop_location_filter: null,
            pick_truck_filter: null,
            delivery_truck_filter: null,
            manual_location_id: null,
            manual_truck_id: null,
            trucks: [],
            trucks_dict: {},
            trucks_being_loaded: true,
            items_being_loaded: false,
            trucks_stats: {},
            default_locsubs: [],
            drop_locsub: null,
            ship_locsub: null,
            delivery_location_filter: null,
            delivery_status_filter: 'all',
            comments_dict: {},
            item_comments_invoice_id: null,
            item_comments_itemid: null,
            sort_asc: true,
            default_location_id: null,
            order_types: [
                { value: 'home_delivery', text: 'HOME DELIVERY' },
                { value: 'store_pickup', text: 'STORE PICKUP' },
                { value: 'store_transfer_order', text: 'STORE TRANSFER' },
            ],
            order_type: null,
            selectAll: false,
            selectedItems: [],
            commonTruck: null,
            originalTrucks: {},
            filtersVisible: true,
            isMobile: false,
            product_search_filter: '',
            invoice_number_filter: '',
            truck_assignment_filter: 'all',
            forceUpdateFlag: false,
            // NEW: Bulk assignment variables
            bulkAssignmentType: null,
            bulkSelectedTruck: null,
            bulkAssignmentTitle: '',
            // NEW: Show same location items toggle
            showSameLocationItems: false
        }
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth < 768;
        },
        getDisplayInvoiceId: function(item) {
            if (item.item_type === 'transfer') {
                return `TRANSFER-${item.transfer_order_id || 'N/A'}`;
            }
            return item.invoice_id || 'N/A';
        },
        getDisplayOrderType: function(item) {
            if (item.item_type === 'transfer') {
                return 'STORE TRANSFER ORDER';
            }
            return (item.order_type || '').toUpperCase();
        },
        getCommentKey: function(item) {
            if (item.item_type === 'transfer') {
                return `TRANSFER_${item.transfer_order_id}_${item.itemid}`;
            }
            return `${item.invoice_id}|${item.itemid}`;
        },
        getDisplayLocsub: function(item) {
            return item.locsub || item.original_locsub;
        },
        updateLocsub: function(item, newValue) {
            this.$set(item, 'original_locsub', newValue);
            this.onFieldChange(item);
        },
        isSelectable: function(item) {
            if (item.item_type === 'transfer') {
                return true;
            }
            return Number(item.state) === 0 || 
                   Number(item.state) === 2 || 
                    Number(item.state) === 9 || 
                   (Number(item.state) === 30 && Number(item.location_id) !== 46);
        },
        
        isDeliveryLocationDisabled: function(item) {
            return !(Number(item.state) === 30 || 
                    Number(item.state) === 9);
        },
        
        getDeliveryLocationOptions: function(item) {
            let opts = [];
            let allLocsubsdict = this.packet.locsubsdict || {};

            if (item.drop_locsub && allLocsubsdict[item.drop_locsub]) {
                opts.push({
                    value: item.drop_locsub,
                    label: allLocsubsdict[item.drop_locsub]
                });
            }

            if (item.order_type === "store_pickup") {
                let storePickupLocsub = "47|162";
                if (allLocsubsdict[storePickupLocsub] && !opts.find(o => o.value === storePickupLocsub)) {
                    opts.push({
                        value: storePickupLocsub,
                        label: allLocsubsdict[storePickupLocsub]
                    });
                }
            }

            if (item.sold_locsub && allLocsubsdict[item.sold_locsub] && 
                !opts.find(o => o.value === item.sold_locsub)) {
                opts.push({
                    value: item.sold_locsub,
                    label: allLocsubsdict[item.sold_locsub]
                });
            }

            if (item.item_type === 'transfer' && item.transfer_to_location_id) {
                const transferLocsub = Object.keys(allLocsubsdict).find(key => {
                    const locationId = key.split('|')[0];
                    return Number(locationId) === Number(item.transfer_to_location_id);
                });
                
                if (transferLocsub && allLocsubsdict[transferLocsub] && 
                    !opts.find(o => o.value === transferLocsub)) {
                    opts.push({
                        value: transferLocsub,
                        label: allLocsubsdict[transferLocsub]
                    });
                }
            }

            let defaultLocsub = "47|131";
            if (allLocsubsdict[defaultLocsub] && !opts.find(o => o.value === defaultLocsub)) {
                opts.push({
                    value: defaultLocsub,
                    label: allLocsubsdict[defaultLocsub]
                });
            }

            if (this.packet.locations) {
                this.packet.locations.forEach(loc => {
                    if (loc.store_id) {
                        const storeLocsub = Object.keys(allLocsubsdict).find(key => {
                            const locationId = key.split('|')[0];
                            return Number(locationId) === Number(loc.id);
                        });
                        
                        if (storeLocsub && allLocsubsdict[storeLocsub] && 
                            !opts.find(o => o.value === storeLocsub)) {
                            opts.push({
                                value: storeLocsub,
                                label: allLocsubsdict[storeLocsub]
                            });
                        }
                    }
                });
            }

            return opts.filter((option, index, self) =>
                index === self.findIndex((t) => t.value === option.value)
            );
        },
        
        isDeliveryTruckDisabled: function(item) {
            // Check if drop location and delivery location are the same
            const areLocationsSame = this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub);
            
            // If locations are the same, disable delivery truck
            if (areLocationsSame) {
                return true;
            }
            
            // Original logic when locations are different
            return !(Number(item.state) === 9) ;
        },
        
        areLocationsSameMainLocation: function(dropLocsub, shipLocsub) {
            if (!dropLocsub || !shipLocsub) return false;
            
            const dropParts = dropLocsub.toString().split('|');
            const shipParts = shipLocsub.toString().split('|');
            
            if (dropParts.length < 2 || shipParts.length < 2) return false;
            
            const dropMain = dropParts[0];
            const shipMain = shipParts[0];
            
            return dropMain === shipMain;
        },

        areLocationsNotSameMainLocation: function(dropLocsub, shipLocsub) {
            if (!dropLocsub || !shipLocsub) return false;
            
            const dropParts = dropLocsub.split('|');
            const shipParts = shipLocsub.split('|');
            
            if (dropParts.length < 2 || shipParts.length < 2) return false;
            
            const dropMain = dropParts[0];
            const shipMain = shipParts[0];
            
            return dropMain !== shipMain;
        },
        
        getTruckStatus: function(item) {
            if (!item.pickup_truck || item.pickup_truck === null || item.pickup_truck === '') {
                return 'NOT ASSIGNED';
            }
            
            if (Number(item.state) === 30) {
                if (this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub)) {
                    return 'COMPLETED';
                } else {
                    return 'COMPLETED';
                }
            }
            
            if (Number(item.state) === 13 || Number(item.state) === 9) {
                if (this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub)) {
                    return 'ASSIGNED';
                } else {
                    return 'COMPLETED';
                }
            }

            if (Number(item.state) === 3) {
                if (this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub)) {
                    return 'PICKED';
                } else {
                    return 'PICKED';
                }
            }
            
            return 'ASSIGNED';
        },
        
        getTruckStatusClass: function(item) {
            const status = this.getTruckStatus(item);
            
            switch(status) {
                case 'COMPLETED':
                    return 'truck-status-delivered';
                case 'PICKED':
                    return 'truck-status-picked';
                case 'DROPPED':
                    return 'truck-status-dropped';
                case 'ASSIGNED':
                    return 'truck-status-assigned';
                case 'NOT ASSIGNED':
                default:
                    return 'truck-status-not-assigned';
            }
        },
        
        getDeliveryStatus: function(item) {
            // Check if drop and delivery locations are the same
            const areLocationsSame = this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub);
            
            if (areLocationsSame) {
                // When locations are the same, sync delivery status with transfer status
                const transferStatus = this.getTruckStatus(item);
                
                // Map transfer status to delivery status
                switch(transferStatus) {
                    case 'COMPLETED':
                        return 'COMPLETED';
                    case 'PICKED':
                        return 'PICKED';
                    case 'DISPATCHED':
                        return 'DISPATCHED';
                    case 'DROPPED':
                        return 'COMPLETED';
                    case 'ASSIGNED':
                        return 'ASSIGNED';
                    case 'NOT ASSIGNED':
                    default:
                        return 'NOT ASSIGNED';
                }
            }
            
            // Original logic when locations are different
            if (!item.truck || item.truck === null || item.truck === '') {
                return 'NOT ASSIGNED';
            }
            
            if (item.truck && (Number(item.state) === 3 || Number(item.state) === 30)) {
                return 'ASSIGNED';
            }
            
            if (Number(item.state) === 10) {
                return 'DISPATCHED';
            }
            if (Number(item.state) === 11) {
                return 'PICKED';
            }
             if (Number(item.state) === 13) {
                return 'DROPPED';
            }
            
            if (Number(item.state) === 13 || Number(item.state) === 4) {
                return 'COMPLETED';
            }
            
            return 'ASSIGNED';
        },
        
        getDeliveryStatusClass: function(item) {
            const status = this.getDeliveryStatus(item);
            
            switch(status) {
                case 'COMPLETED':
                    return 'delivery-status-delivered';
                case 'PICKED':
                    return 'delivery-status-in-picked';
                case 'DROPPED':
                    return 'delivery-status-dropped';
                case 'DISPATCHED':
                    return 'delivery-status-dispatched';
                case 'PICKED':
                    return 'delivery-status-in-picked';    
                case 'ASSIGNED':
                    return 'delivery-status-assigned';
                case 'NOT ASSIGNED':
                default:
                    return 'delivery-status-not-assigned';
            }
        },

        shouldShowDeliveryTruck: function(item) {
            // Don't show delivery truck if locations are the same
            return !this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub);
        },

        checkAndSyncDeliveryStatus: function(item) {
            // Check if both locations are set and are the same
            if (item.ship_locsub && item.drop_locsub) {
                const areLocationsSame = this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub);
                
                if (areLocationsSame) {
                    // Clear delivery truck when locations are the same
                    if (item.truck && item.truck !== '') {
                        item.truck = null;
                        this.$set(item, 'truck_modified', true);
                    }
                    
                    // Force update to reflect changes immediately
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });
                }
            }
        },

        filterItems: function () {
            if (!Array.isArray(this.items)) {
                this.filteredItems = [];
                return;
            }

            this.filteredItems = this.items.filter(item => {
                if (!item) return false;

                const orderTypeMatch = 
                    this.order_type === null ||
                    (item.item_type === 'transfer' && this.order_type === 'store_transfer_order') ||
                    item.order_type === this.order_type;

                const stateMatch = 
                    this.state === null ||
                    Number(item.state) === Number(this.state);

                const productSearch = !this.product_search_filter || 
                    (item.product_sku && item.product_sku.toLowerCase()
                        .includes(this.product_search_filter.toLowerCase())) ||
                    (item.product_name && item.product_name.toLowerCase()
                        .includes(this.product_search_filter.toLowerCase()));

                const invoiceMatch = !this.invoice_number_filter || 
                    this.getDisplayInvoiceId(item).toString()
                        .toLowerCase()
                        .includes(this.invoice_number_filter.toLowerCase());

                const truckMatch = this.pick_truck_filter === null ||
                    (this.pick_truck_filter && item.pickup_truck === this.pick_truck_filter) ||
                    (!this.pick_truck_filter && this.pick_truck_filter === null);

                const deliveryTruckMatch = this.delivery_truck_filter === null ||
                    (this.delivery_truck_filter && item.truck === this.delivery_truck_filter) ||
                    (!this.delivery_truck_filter && this.delivery_truck_filter === null);

                const deliveryLocationMatch = this.delivery_location_filter === null ||
                    (item.drop_locsub && parseInt(item.drop_locsub.split("|")[0], 10) === this.delivery_location_filter);

                let truckAssignmentMatch = true;
                const truckStatus = this.getTruckStatus(item);
                
                if (this.truck_assignment_filter === 'assigned') {
                    truckAssignmentMatch = truckStatus === 'ASSIGNED' || truckStatus === 'PICKED' || truckStatus === 'DROPPED';
                } else if (this.truck_assignment_filter === 'not_assigned') {
                    truckAssignmentMatch = truckStatus === 'NOT ASSIGNED';
                } else if (this.truck_assignment_filter === 'completed') {
                    truckAssignmentMatch = truckStatus === 'COMPLETED';
                } else if (this.truck_assignment_filter === 'picked') {
                    truckAssignmentMatch = truckStatus === 'PICKED';
                } else if (this.truck_assignment_filter === 'dropped') {
                    truckAssignmentMatch = truckStatus === 'DROPPED';
                }

                let deliveryStatusMatch = true;
                const deliveryStatus = this.getDeliveryStatus(item);
                
                if (this.delivery_status_filter === 'assigned') {
                    deliveryStatusMatch = deliveryStatus === 'ASSIGNED';
                } else if (this.delivery_status_filter === 'not_assigned') {
                    deliveryStatusMatch = deliveryStatus === 'NOT ASSIGNED';
                } else if (this.delivery_status_filter === 'dropped') {
                    deliveryStatusMatch = deliveryStatus === 'DROPPED';
                  } else if (this.delivery_status_filter === 'picked') {
                    deliveryStatusMatch = deliveryStatus === 'PICKED';
                } else if (this.delivery_status_filter === 'completed') {
                    deliveryStatusMatch = deliveryStatus === 'COMPLETED';
                }

                let truckTypeMatch = true;
                if (this.truck_type_filter === 'pickup') {
                    truckTypeMatch = this.areLocationsNotSameMainLocation(item.drop_locsub, item.ship_locsub);
                } else if (this.truck_type_filter === 'delivery') {
                    truckTypeMatch = this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub);
                }

                return orderTypeMatch && stateMatch && productSearch && invoiceMatch && 
                       truckMatch && deliveryTruckMatch && deliveryLocationMatch && 
                       truckAssignmentMatch && truckTypeMatch && deliveryStatusMatch;
            });
        },

        applyTextFilters() {
            this.filterItems();
        },
        
        clearTextFilters() {
            this.product_search_filter = '';
            this.invoice_number_filter = '';
            this.filterItems();
        },

        buildLocsubOptions: function(item) {
            let opts = [];

            if (item.item_type === 'transfer') {
                let defaultLocsub = "47|131";
                opts.push({
                    value: defaultLocsub,
                    label: this.packet.locsubsdict[defaultLocsub] || "Default Location"
                });

                if (item.drop_locsub && !opts.find(o => o.value === item.drop_locsub)) {
                    opts.push({
                        value: item.drop_locsub,
                        label: this.packet.locsubsdict[item.drop_locsub] || item.drop_locsub
                    });
                }

                return opts;
            }

            let defaultLocsub = item.order_type === "store_pickup" ? "47|162" : "47|131";

            opts.push({
                value: defaultLocsub,
                label: this.packet.locsubsdict[defaultLocsub] || "Default Location"
            });

            if (item.sold_locsub && !opts.find(o => o.value === item.sold_locsub)) {
                opts.push({
                    value: item.sold_locsub,
                    label: this.packet.locsubsdict[item.sold_locsub] || item.sold_locsub
                });
            }

            if (item.drop_locsub && !opts.find(o => o.value === item.drop_locsub)) {
                opts.push({
                    value: item.drop_locsub,
                    label: this.packet.locsubsdict[item.drop_locsub] || item.drop_locsub
                });
            }

            return opts;
        },

        buildStageLocsubOptions: function(item) {
            let opts = [];

            if (item.item_type === 'transfer') {
                let allLocsubsdict = this.packet.locsubsdict || {};

                if (item.ship_locsub && allLocsubsdict[item.ship_locsub]) {
                    opts.push({
                        value: item.ship_locsub,
                        label: allLocsubsdict[item.ship_locsub]
                    });
                }

                if (item.drop_locsub && allLocsubsdict[item.drop_locsub]) {
                    opts.push({
                        value: item.drop_locsub,
                        label: allLocsubsdict[item.drop_locsub]
                    });
                }

                let defaultLocsub = "47|131";
                if (allLocsubsdict[defaultLocsub] && !opts.find(o => o.value === defaultLocsub)) {
                    opts.push({
                        value: defaultLocsub,
                        label: allLocsubsdict[defaultLocsub]
                    });
                }

                return opts.filter((option, index, self) =>
                    index === self.findIndex((t) => t.value === option.value)
                );
            }

            let allLocsubsdict = this.packet.locsubsdict || {};

            if (item.ship_locsub && allLocsubsdict[item.ship_locsub]) {
                opts.push({
                    value: item.ship_locsub,
                    label: allLocsubsdict[item.ship_locsub]
                });
            }

            if (item.drop_locsub && allLocsubsdict[item.drop_locsub]) {
                opts.push({
                    value: item.drop_locsub,
                    label: allLocsubsdict[item.drop_locsub]
                });
            }

            let defaultLocsub = item.order_type === "store_pickup" ? "47|162" : "47|131";
            if (allLocsubsdict[defaultLocsub] && !opts.find(o => o.value === defaultLocsub)) {
                opts.push({
                    value: defaultLocsub,
                    label: allLocsubsdict[defaultLocsub]
                });
            }

            if (item.sold_locsub && allLocsubsdict[item.sold_locsub] && 
                !opts.find(o => o.value === item.sold_locsub)) {
                opts.push({
                    value: item.sold_locsub,
                    label: allLocsubsdict[item.sold_locsub]
                });
            }

            return opts.filter((option, index, self) =>
                index === self.findIndex((t) => t.value === option.value)
            );
        },

        concater: function (items) {
            let out = items.join("|")
            return out
        },

       allowed: function (item) {
    let status = true;
    
    if (this.location_filter != null) {
        if (item.item_type === 'transfer') {
            if (item.pick_location_id != this.location_filter) {
                status = false;
            }
        } else {
            if (item.pick_location_id != this.location_filter) {
                status = false;
            }
        }
    }

    if (this.drop_location_filter != null) {
        if (item.ship_locsub && parseInt(item.ship_locsub.split("|")[0], 10) !== this.drop_location_filter) {
            status = false;
        }
    }

    if (this.delivery_truck_filter != null) {
        if (item.truck != this.delivery_truck_filter) {
            status = false;
        }
    }

    if (this.delivery_location_filter != null) {
        if (item.drop_locsub) {
            const dropLocationId = parseInt(item.drop_locsub.split("|")[0], 10);
            if (dropLocationId !== this.delivery_location_filter) {
                status = false;
            }
        } else {
            status = false;
        }
    }

    if (this.pick_truck_filter != null) {
        if (item.pickup_truck != this.pick_truck_filter) {
            status = false;
        }
    }

    if (item.quantity <= 0) {
        status = false;
    }

    return status
},

        search_dates: function(e) {
            if (e) {
                e.preventDefault();
            }

            if (!this.query.startDate || !this.query.endDate) {
                this.$bvToast.toast(
                    "Please select a date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                return;
            }

            this.get_pick_items_for_date();
        },

        get_pick_items_for_date: function () {
            let path = "/api/sales/get_pickup_items_WH_TRANSFER/"
            let data = {
                startDate: this.query.startDate,
                endDate: this.query.endDate,
                merchandise_status: [1],
                order_type: this.order_type,
                state: this.state ? Number(this.state) : null,
            }
            let that = this;

            let s = function (response) {
                if (response.data.result) {
                    that.items = response.data.result.map(item => {
                        that.originalValues[item.itemid] = {
                            pickup_truck: item.pickup_truck || null,
                            truck: item.truck || null,
                            drop_locsub: item.drop_locsub || null,
                            locsub: item.locsub || null,
                            ship_locsub: item.ship_locsub || null
                        };

                        return item;
                    });

                    that.update_trucks_stats();
                    that.get_batch_comments();
                    that.filterItems();
                    that.selectedItems = [];
                    that.selectAll = false;
                    that.commonTruck = null;
                    that.forceUpdateFlag = !that.forceUpdateFlag;
                }
                else {
                    console.log(response.data.error)
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
                that.items_being_loaded = false
            }

            let f = function (error) {
                console.log(error, "ees")
                that.$bvToast.toast(
                    "Error loading pickups for date range.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
                that.items_being_loaded = false
            }

            this.items_being_loaded = true;
            Requestor.postSync(path, data, s, f);
        },

        isItemModified: function(item) {
            if (!this.originalValues[item.itemid]) {
                return true;
            }

            const original = this.originalValues[item.itemid];
            
            console.log('Item:', item.itemid);
            console.log('Current delivery truck:', item.truck);
            console.log('Original delivery truck:', original.truck);
            console.log('Are they different?', String(item.truck) !== String(original.truck));
            
            const hasPickupTruckChange = String(item.pickup_truck) !== String(original.pickup_truck);
            const hasDeliveryTruckChange = String(item.truck) !== String(original.truck);
            const hasDropLocsubChange = String(item.drop_locsub) !== String(original.drop_locsub);
            const hasLocsubChange = String(item.locsub) !== String(original.locsub);
            const hasShipLocsubChange = String(item.ship_locsub) !== String(original.ship_locsub);
            
            const isModified = hasPickupTruckChange || hasDeliveryTruckChange || 
                            hasDropLocsubChange || hasLocsubChange || hasShipLocsubChange;
            
            console.log('Is modified?', isModified);
            
            return isModified;
        },

        onFieldChange: function(item) {
            this.forceUpdateFlag = !this.forceUpdateFlag;
            this.$forceUpdate();
        },

        onPickupTruckChange: function(item) {
            this.onFieldChange(item);
        },

        onDeliveryTruckChange: function(item) {
            this.$set(item, 'truck_modified', true);
            this.forceUpdateFlag = !this.forceUpdateFlag;
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
        
        onDropLocsubChange: function(item) {
            this.checkAndSyncDeliveryStatus(item);
            this.onFieldChange(item);
        },

        onShipLocsubChange: function(item) {
            this.checkAndSyncDeliveryStatus(item);
            this.onFieldChange(item);
        },

        get_order_type_color: function (order_type, pickup_type, item_type) {
            if (item_type === 'transfer') {
                return '#ffd54f';
            }
            
            const type = (order_type || pickup_type || '').toUpperCase();

            if (type === 'STORE_PICKUP') {
                return '#c5e1a5';
            }
            else if (type === 'HOME_DELIVERY') {
                return '#b3e5fc';
            }
            else if (type === 'STORE_TRANSFER_ORDER') {
                return '#ffd54f';
            }
            else {
                return '#efefef';
            }
        },

        show_comments: function (item) {
            this.item_comments_invoice_id = this.getDisplayInvoiceId(item);
            this.item_comments_itemid = item.itemid;
            this.$bvModal.show("modal-comments-process-pickups");
        },

        save_pickup_item: function (item) {
            if (!this.isItemModified(item)) {
                this.$bvToast.toast(
                    "No changes to save for this item.",
                    { title: "Info", autoHideDelay: 1500, variant: "info" }
                );
                return;
            }

            let path = "/api/sales/update_invoice_items_process_pickups/"
            let data = {
                invoice_id: item.invoice_id,
                itemid: item.itemid,
                pickup_truck: item.pickup_truck,
                truck: item.truck,
                drop_locsub: item.drop_locsub,
                locsub: item.locsub,
                ship_locsub: item.ship_locsub,
                item_type: item.item_type || 'invoice',
            }
            
            if (item.item_type === 'transfer' && item.transfer_order_id) {
                data.transfer_order_id = item.transfer_order_id;
            }

            let that = this;
            let s = function (response) {
                if (!response.data.error) {
                    that.originalValues[item.itemid] = {
                        pickup_truck: item.pickup_truck,
                        truck: item.truck,
                        drop_locsub: item.drop_locsub,
                        locsub: item.locsub,
                        ship_locsub: item.ship_locsub
                    };

                    that.$bvToast.toast(
                        "Updated item's pickup/delivery details.",
                        { title: "Success", autoHideDelay: 1500, variant: "success" }
                    );
                    
                    that.forceUpdateFlag = !that.forceUpdateFlag;
                }
                else {
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
            }

            let f = function (error) {
                that.$bvToast.toast(
                    "Error updating item's pickup/delivery details.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
            }
            Requestor.postAsync(path, data, s, f);
        },

        update_trucks_stats: function (item) {
            let that = this;
            this.trucks_stats = {}
            for (var i = 0; i < this.items.length; i++) {
                let it = this.items[i];
                let truck = it.pickup_truck;

                if (truck in this.trucks_stats) {
                    this.trucks_stats[truck] += (parseInt(it.cubes) || 0);
                }
                else {
                    this.trucks_stats[truck] = (parseInt(it.cubes) || 0);
                }
            }

            for (var i = 0; i < this.trucks.length; i++) {
                this.trucks[i].cube_count = 0;
                this.trucks[i].cube_count = parseInt(this.trucks_stats[this.trucks[i].value]);
            }

            if (item) {
                this.save_pickup_item(item);
            }
            return
        },

        update_selected_trucks_stats() {
            if (this.selectedItems.length > 1 && this.commonTruck) {
                this.selectedItems.forEach(selected => {
                    const index = this.items.findIndex(it => it.itemid === selected.itemid);
                    if (index === -1) return;

                    const current = this.items[index];

                    if (this.isDisabled(current) || current.state == 5) return;

                    if (!this.originalTrucks[selected.itemid]) {
                        this.originalTrucks[selected.itemid] = selected.pickup_truck;
                    }

                    selected.pickup_truck = this.commonTruck;
                    current.pickup_truck = this.commonTruck;
                });
                this.onFieldChange();
            }
        },

        save_selected_pickup_items: function() {
            let path = "/api/sales/update_invoice_items_process_pickups/";

            const savableItems = this.selectedItems.filter(item => {
                if (!this.isItemModified(item)) {
                    return false;
                }
                
                const original = this.originalValues[item.itemid];
                const hasDeliveryTruckChange = original && 
                    String(item.truck) !== String(original.truck);
                
                if (hasDeliveryTruckChange) {
                    const state = Number(item.state);
                    const allowedStatesForDeliveryTruck = [30, 11, 13, 9];
                    
                    if (allowedStatesForDeliveryTruck.includes(state)) {
                        return true;
                    }
                }
                
                return !this.isDisabled(item);
            });

            if (savableItems.length === 0) {
                this.$bvToast.toast(
                    "No valid changes to save in selected items.",
                    { title: "Info", autoHideDelay: 1500, variant: "info" }
                );
                return;
            }

            let that = this;
            let savedCount = 0;
            let errorCount = 0;

            savableItems.forEach(item => {
                let data = {
                    invoice_id: item.invoice_id,
                    itemid: item.itemid,
                    pickup_truck: item.pickup_truck,
                    truck: item.truck,
                    drop_locsub: item.drop_locsub,
                    locsub: item.locsub,
                    ship_locsub: item.ship_locsub,
                    item_type: item.item_type || 'invoice',
                };
                
                if (item.item_type === 'transfer' && item.transfer_order_id) {
                    data.transfer_order_id = item.transfer_order_id;
                }

                let s = function (response) {
                    if (!response.data.error) {
                        that.originalValues[item.itemid] = {
                            pickup_truck: item.pickup_truck,
                            truck: item.truck,
                            drop_locsub: item.drop_locsub,
                            locsub: item.locsub,
                            ship_locsub: item.ship_locsub
                        };
                        savedCount++;

                        if (savedCount + errorCount === savableItems.length) {
                            that.$bvToast.toast(
                                `Updated ${savedCount} of ${savableItems.length} item(s).`,
                                { title: "Success", autoHideDelay: 1500, variant: "success" }
                            );

                            that.selectedItems = [];
                            that.selectAll = false;
                            that.commonTruck = null;
                            that.forceUpdateFlag = !that.forceUpdateFlag;
                        }
                    } else {
                        errorCount++;
                        that.$bvToast.toast(
                            `Error updating item ${item.invoice_id}: ${response.data.error}`,
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                };

                let f = function (error) {
                    errorCount++;
                    that.$bvToast.toast(
                        `Error updating item ${item.invoice_id}`,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                };

                Requestor.postAsync(path, data, s, f);
            });
        },

        get_batch_comments: function () {
            let items = this.items.map(function (d) {
                return { 
                    invoice_id: d.invoice_id, 
                    itemid: d.itemid,
                    item_type: d.item_type || 'invoice',
                    transfer_order_id: d.transfer_order_id
                }
            })
            let path = "/api/sales/get_batch_comments/"
            let data = { items: items };
            let that = this;
            let s = function (response) {
                if (response.data.result) {
                    let comments = response.data.result;
                    if (comments.length > 0) {
                        that.comments_dict = Object.assign({}, ...comments.map((x) => ({ 
                            [x.item_type === 'transfer' ? 
                                `TRANSFER_${x.transfer_order_id}_${x.itemid}` : 
                                `${x.invoice_id}|${x.itemid}`]: x.n_comments 
                        })));
                    }
                }
                else {
                    console.log(response.data.error)
                    that.$bvToast.toast(
                        response.data.error,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                }
            }

            let f = function (error) {
                that.$bvToast.toast(
                    "Error loading comments.",
                    { title: "Error", autoHideDelay: 1500, variant: "warning" }
                );
            }

            Requestor.postAsync(path, data, s, f);
        },

        fetch_prereqs: function (order_type) {
            let that = this;
            let prereqs = [
                {
                    path: "/api/user/get_trucks/",
                    data: {},
                    type: "",
                    executable: Requestor.getAsync,
                    s: function (response) {
                        if (response.data.result) {
                            that.trucks = response.data.result.filter(item => item.userrole === "housetruck").map(function (d) {
                                return {
                                    value: d.id,
                                    text: d.username,
                                    cube_count: 0
                                }
                            });

                            that.trucks.forEach((el, index) => that.trucks_dict[el.value] = el.text);

                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                { title: "Error", autoHideDelay: 1500, variant: "warning" }
                            );
                        }
                        that.trucks_being_loaded = false;
                    },
                    f: function (error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading trucks.",
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                },
                {
                    path: "/api/inventory/get_all_loc_inventory_dict/",
                    data: {},
                    type: "",
                    executable: Requestor.getAsync,
                    s: function (response) {
                        if (response.data.result) {
                            that.all_loc_inventory_dict = response.data.result;
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                { title: "Error", autoHideDelay: 1500, variant: "warning" }
                            );
                        }
                    },
                    f: function (error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading inventory.",
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                },
                {
                    path: "/api/sales/get_default_locsubs/",
                    data: {},
                    type: "",
                    executable: Requestor.getAsync,
                    s: function (response) {
                        if (response.data.result.length > 0) {
                            that.default_locsubs = response.data.result;
                            that.drop_locsub = that.default_locsubs.filter(function (d) { return d.name == 'drop_locsub' })[0].locsub;
                            that.default_location_id = parseInt(that.drop_locsub.split("|")[0])
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                { title: "Error", autoHideDelay: 1500, variant: "warning" }
                            );
                        }
                    },
                    f: function (error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading default locations.",
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                },
            ];

            for (var i = 0; i < prereqs.length; i++) {
                let path = prereqs[i]["path"];
                let data = prereqs[i]["data"];
                let s = prereqs[i]["s"];
                let f = prereqs[i]["f"];
                let type = prereqs[i]["type"];
                if (type == "secure") {
                    prereqs[i]["executable"](path, data, this, s, f);
                }
                else {
                    prereqs[i]["executable"](path, data, s, f);
                }
            }
        },

        sortby: function (key, mapper) {
            if (this.sort_asc) {
                this.items = Requestor.sort(this.items, key, mapper)
            }
            else {
                this.items = Requestor.sort_reverse(this.items, key, mapper)
            }
            this.sort_asc = !this.sort_asc;
        },

        get_csv_data: function () {
            let data = []
            let items = this.items;
            let that = this;
            if (items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    let row = items[i];
                    data.push(
                        {
                            invoice_id: this.getDisplayInvoiceId(row),
                            product_name: row.product_name,
                            product_sku: row.product_sku,
                            quantity: row.quantity,
                            order_type: this.getDisplayOrderType(row),
                            pick_location: this.packet.locsubsdict[row.locsub],
                            drop_location: this.packet.locsubsdict[row.drop_locsub],
                            pickup_truck: this.packet.trucksdict[row.pickup_truck],
                            delivery_truck: this.packet.trucksdict[row.truck],
                            item_type: row.item_type || 'invoice',
                            transfer_status: this.getTruckStatus(row),
                            delivery_status: this.getDeliveryStatus(row)
                        }
                    )
                }
            }
            return data
        },

        get_csv_filename: function () {
            let startDate = this.query.startDate;
            let endDate = this.query.endDate;
            return `PICKLIST_${startDate}_TO_${endDate}.csv`;
        },

        isDisabled: function (item) {
            if (item.item_type === 'transfer') {
                return false;
            }
            return item.locsub == '46|122' || Number(item.state) == 3 || Number(item.state) == 30 || Number(item.state) == 10 || Number(item.state) == 11 || Number(item.state) == 13;
        },

        isPickLocationDisabled: function (item) {
            if (item.item_type === 'transfer') {
                return false;
            }
            return Number(item.state) == 3 || Number(item.state) == 30 || Number(item.state) == 10 || Number(item.state) == 11 || Number(item.state) == 13;
        },

        toggleSelectAll() {
            if (this.selectAll) {
                this.selectedItems = this.displayItems.filter(item => this.isSelectable(item));
            } else {
                this.selectedItems = [];
            }
            this.onFieldChange();
        },

        getAvailableLocsubs: function(item) {
            if (!item || !this.all_loc_inventory_dict) return [];

            return this.packet.locsubs.filter(locsub => {
                if (!locsub) return false;

                if (item.locsub === locsub.value) {
                    return true;
                }

                const inventoryKey = this.concater([item.product_sku, locsub.location_id, locsub.sublocation_id]);
                const inventoryCount = this.all_loc_inventory_dict[inventoryKey] || 0;
                return inventoryCount > 0;
            });
        },

        isOutOfStock: function(item, locsub) {
            if (!item || !locsub || !this.all_loc_inventory_dict) return false;

            const inventoryKey = this.concater([item.product_sku, locsub.location_id, locsub.sublocation_id]);
            const inventoryCount = this.all_loc_inventory_dict[inventoryKey] || 0;

            return inventoryCount <= 0;
        },

        initDatePicker: function() {
            const Lightpick = require('lightpick');
            let that = this;
            
            var picker = new Lightpick({
                field: document.getElementById('dates'),
                singleDate: false,
                repick: true,
                format: 'YYYY-MM-DD',
                onSelect: function(start, end) {
                    that.query.startDate = start ? start.format('YYYY-MM-DD') : '';
                    that.query.endDate = end ? end.format('YYYY-MM-DD') : '';
                    if (start && end) {
                        that.get_pick_items_for_date();
                    }
                }
            });
            
            picker.setDate(moment().toDate());
        },

        // NEW: Toggle show same location items
        toggleShowSameLocationItems: function() {
            this.showSameLocationItems = !this.showSameLocationItems;
            this.filterItems();
        },

        // NEW: Bulk assignment methods
        bulkAssignPickupTruck: function() {
            if (this.selectedItems.length === 0) {
                this.$bvToast.toast(
                    "Please select items to assign pickup truck.",
                    { title: "Info", autoHideDelay: 1500, variant: "info" }
                );
                return;
            }

            this.bulkAssignmentType = 'pickup';
            this.bulkAssignmentTitle = `Assign Pickup Truck to ${this.selectedItems.length} Items`;
            this.bulkSelectedTruck = null;
            this.$bvModal.show('modal-bulk-assign-truck');
        },

        bulkAssignDeliveryTruck: function() {
            if (this.selectedItems.length === 0) {
                this.$bvToast.toast(
                    "Please select items to assign delivery truck.",
                    { title: "Info", autoHideDelay: 1500, variant: "info" }
                );
                return;
            }

            // Filter out items where delivery truck should be disabled
            const assignableItems = this.selectedItems.filter(item => 
                this.shouldShowDeliveryTruck(item) && !this.isDeliveryTruckDisabled(item)
            );
            
            if (assignableItems.length === 0) {
                this.$bvToast.toast(
                    "Selected items don't require delivery trucks (same location) or are not eligible.",
                    { title: "Info", autoHideDelay: 1500, variant: "info" }
                );
                return;
            }

            this.bulkAssignmentType = 'delivery';
            this.bulkAssignmentTitle = `Assign Delivery Truck to ${assignableItems.length} Items`;
            this.bulkSelectedTruck = null;
            this.$bvModal.show('modal-bulk-assign-truck');
        },

        confirmBulkAssignment: function() {
            if (!this.bulkSelectedTruck || this.selectedItems.length === 0) {
                return;
            }

            let that = this;
            let updatedCount = 0;
            let errorCount = 0;

            // Filter items based on assignment type and eligibility
            const assignableItems = this.selectedItems.filter(item => {
                if (this.bulkAssignmentType === 'pickup') {
                    return !this.isDisabled(item) && item.state != 5;
                } else if (this.bulkAssignmentType === 'delivery') {
                    return this.shouldShowDeliveryTruck(item) && !this.isDeliveryTruckDisabled(item);
                }
                return false;
            });

            if (assignableItems.length === 0) {
                this.$bvToast.toast(
                    `No ${this.bulkAssignmentType} assignable items in selection.`,
                    { title: "Warning", autoHideDelay: 1500, variant: "warning" }
                );
                this.$bvModal.hide('modal-bulk-assign-truck');
                return;
            }

            assignableItems.forEach(item => {
                // Update the item locally
                if (this.bulkAssignmentType === 'pickup') {
                    item.pickup_truck = this.bulkSelectedTruck;
                    this.$set(item, 'pickup_truck_modified', true);
                } else if (this.bulkAssignmentType === 'delivery') {
                    item.truck = this.bulkSelectedTruck;
                    this.$set(item, 'truck_modified', true);
                }

                // Save to backend
                let data = {
                    invoice_id: item.invoice_id,
                    itemid: item.itemid,
                    pickup_truck: this.bulkAssignmentType === 'pickup' ? this.bulkSelectedTruck : item.pickup_truck,
                    truck: this.bulkAssignmentType === 'delivery' ? this.bulkSelectedTruck : item.truck,
                    drop_locsub: item.drop_locsub,
                    locsub: item.locsub,
                    ship_locsub: item.ship_locsub,
                    item_type: item.item_type || 'invoice',
                };

                if (item.item_type === 'transfer' && item.transfer_order_id) {
                    data.transfer_order_id = item.transfer_order_id;
                }

                let s = function (response) {
                    if (!response.data.error) {
                        that.originalValues[item.itemid] = {
                            pickup_truck: item.pickup_truck,
                            truck: item.truck,
                            drop_locsub: item.drop_locsub,
                            locsub: item.locsub,
                            ship_locsub: item.ship_locsub
                        };
                        updatedCount++;

                        if (updatedCount + errorCount === assignableItems.length) {
                            that.$bvToast.toast(
                                `${this.bulkAssignmentType === 'pickup' ? 'Pickup' : 'Delivery'} truck assigned to ${updatedCount} item(s).`,
                                { title: "Success", autoHideDelay: 1500, variant: "success" }
                            );

                            that.forceUpdateFlag = !that.forceUpdateFlag;
                            that.$bvModal.hide('modal-bulk-assign-truck');
                            that.bulkSelectedTruck = null;
                        }
                    } else {
                        errorCount++;
                        that.$bvToast.toast(
                            `Error updating item ${item.invoice_id}: ${response.data.error}`,
                            { title: "Error", autoHideDelay: 1500, variant: "warning" }
                        );
                    }
                }.bind(this);

                let f = function (error) {
                    errorCount++;
                    that.$bvToast.toast(
                        `Error updating item ${item.invoice_id}`,
                        { title: "Error", autoHideDelay: 1500, variant: "warning" }
                    );
                };

                Requestor.postAsync("/api/sales/update_invoice_items_process_pickups/", data, s, f);
            });
        },
    },

    computed: {
        truckTypeOptions() {
            return [
                { value: 'all', text: 'ALL TYPES' },
                { value: 'pickup', text: 'PICKUP TRUCK' },
                { value: 'delivery', text: 'DELIVERY TRUCK' }
            ];
        },
        
        deliveryLocationOptions() {
            const deliveryLocations = new Set();
            
            this.items.forEach(item => {
                if (item.drop_locsub) {
                    const locationId = item.drop_locsub.split('|')[0];
                    deliveryLocations.add(parseInt(locationId));
                }
            });
            
            return Array.from(deliveryLocations).map(locId => {
                let locationName = `Location ${locId}`;
                
                if (this.packet.locations) {
                    const location = this.packet.locations.find(loc => Number(loc.id) === Number(locId));
                    if (location && location.location) {
                        locationName = location.location;
                    }
                }
                
                if (this.packet.locsubsdict) {
                    for (const [key, value] of Object.entries(this.packet.locsubsdict)) {
                        if (key.startsWith(`${locId}|`)) {
                            const parts = value.split(' | ');
                            if (parts[0]) {
                                locationName = parts[0];
                                break;
                            }
                        }
                    }
                }
                
                return {
                    value: parseInt(locId),
                    text: locationName
                };
            }).sort((a, b) => a.text.localeCompare(b.text));
        },
        
        limitedStatusOptions() {
            const requiredStatuses = [
                0,   // NEW
                2,   // PULLED
                3,   // PICKED FROM WAREHOUSE
                30,  // DROPPED AT MECCA SHIPPING
                14, 
                15,
                11,  // PICKED FROM MECCA SHIPPING
                13,  // DROPPED AT STORE
                9,   // RECEIVED FROM WAREHOUSE
                10,  // DISPATCHED FOR STORE
            ];
            
            return mappings.states
                .filter(state => requiredStatuses.includes(state.value))
                .map(state => ({
                    value: state.value,
                    text: state.text
                }));
        },
        
        selectAll: {
            get() {
                const selectableItems = this.displayItems.filter(item => this.isSelectable(item));
                return selectableItems.length > 0 &&
                    this.selectedItems.length === selectableItems.length;
            },
            set(value) {
                if (value) {
                    this.selectedItems = this.displayItems.filter(item => this.isSelectable(item));
                } else {
                    this.selectedItems = [];
                }
            }
        },
        
        filteredItemsByLocation: function() {
            const shouldApplyFilter = !this.showSameLocationItems;
            
            return this.filteredItems.filter(item => {
                // Only apply the filter if showSameLocationItems is false
                if (shouldApplyFilter) {
                    const areLocationsSame = this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub);
                    const transferStatus = this.getTruckStatus(item);
                    
                    // Hide if locations are same AND transfer status is NOT "NOT ASSIGNED"
                    if (areLocationsSame && transferStatus !== 'NOT ASSIGNED') {
                        return false; // Hide this item
                    }
                }
                
                return true; // Show this item
            });
        },
        
     displayItems() {
    const shouldApplyFilter = !this.showSameLocationItems;
    
    // Check if ANY filter is active
    const hasActiveFilters = this.order_type !== null || 
                            this.state !== null || 
                            this.product_search_filter || 
                            this.invoice_number_filter ||
                            this.truck_assignment_filter !== 'all' || 
                            this.delivery_status_filter !== 'all' ||
                            this.pick_truck_filter !== null ||
                            this.delivery_truck_filter !== null || 
                            this.delivery_location_filter !== null || 
                            this.truck_type_filter !== 'all' ||
                            this.location_filter !== null ||
                            this.drop_location_filter !== null;
    
    // If filters are active, show all items (including same location)
    if (hasActiveFilters) {
        return (this.order_type !== null || this.state !== null || 
                this.product_search_filter || this.invoice_number_filter ||
                this.truck_assignment_filter !== 'all' || 
                this.delivery_status_filter !== 'all' ||
                this.pick_truck_filter !== null ||
                this.delivery_truck_filter !== null || this.delivery_location_filter !== null || 
                this.truck_type_filter !== 'all')
            ? this.filteredItems
            : this.items;
    }
    
    // No filters active - apply default hiding of same-location items
    return this.items.filter(item => {
        const areLocationsSame = this.areLocationsSameMainLocation(item.drop_locsub, item.ship_locsub);
        const transferStatus = this.getTruckStatus(item);
        
        // Hide if locations are same AND transfer status is NOT "NOT ASSIGNED"
        if (areLocationsSame && transferStatus !== 'NOT ASSIGNED') {
            return false; // Hide this item
        }
        
        return true; // Show this item
    });
},
        
        showSaveButton() {
            const flag = this.forceUpdateFlag;
            
            if (this.selectedItems.length === 0) {
                console.log('No items selected');
                return false;
            }

            const savableItems = this.selectedItems.filter(item => {
                if (!this.isItemModified(item)) {
                    console.log(`Item ${item.itemid}: not modified`);
                    return false;
                }
                
                const original = this.originalValues[item.itemid];
                const hasDeliveryTruckChange = original && 
                    String(item.truck) !== String(original.truck);
                
                if (hasDeliveryTruckChange) {
                    const state = Number(item.state);
                    const allowedStatesForDeliveryTruck = [30, 11, 13, 9];
                    
                    if (allowedStatesForDeliveryTruck.includes(state)) {
                        console.log(`Item ${item.itemid}: delivery truck change in allowed state ${state}`);
                        return true;
                    }
                }
                
                const notDisabled = !this.isDisabled(item);
                console.log(`Item ${item.itemid}: modified=true, notDisabled=${notDisabled}`);
                return notDisabled;
            });
            
            console.log('Savable items count:', savableItems.length);
            console.log('Show save button?', savableItems.length > 0);
            
            return savableItems.length > 0;
        },
        
        saveButtonText() {
            if (this.selectedItems.length === 0) return "Save";

            const modifiedCount = this.selectedItems.filter(item =>
                this.isItemModified(item) && !this.isDisabled(item)
            ).length;

            if (modifiedCount === 1) return "Save Item";
            return `Save Items (${modifiedCount})`;
        },
        
        hasActiveTextFilters() {
            return this.product_search_filter || this.invoice_number_filter;
        },
        
        truckStatusOptions() {
            return [
                { value: 'not_assigned', text: 'NOT ASSIGNED' },
                { value: 'assigned', text: 'ASSIGNED' },
                { value: 'picked', text: 'PICKED' },
                { value: 'dropped', text: 'DROPPED' },
                { value: 'completed', text: 'COMPLETED' },
                { value: 'all', text: 'ALL STATUSES' }
            ];
        },
        
        deliveryStatusOptions() {
            return [
                { value: 'not_assigned', text: 'NOT ASSIGNED' },
                { value: 'assigned', text: 'ASSIGNED' },
                { value: 'picked', text: 'PICKED' },
                { value: 'dropped', text: 'DROPPED' },
                { value: 'completed', text: 'COMPLETED' },
                { value: 'all', text: 'ALL STATUSES' }
            ];
        },

        // NEW: Computed properties for bulk assignment
        hasPickupAssignableItems() {
            return this.selectedItems.some(item => !this.isDisabled(item) && item.state != 5);
        },

        hasDeliveryAssignableItems() {
            return this.selectedItems.some(item => this.shouldShowDeliveryTruck(item) && !this.isDeliveryTruckDisabled(item));
        },
    },
    
    watch: {
        truck_type_filter() {
            this.filterItems();
        },
        state() {
            this.filterItems();
        },
        order_type() {
            this.filterItems();
        },
        product_search_filter() {
            this.filterItems();
        },
        invoice_number_filter() {
            this.filterItems();
        },
        pick_truck_filter() {
            this.filterItems();
        },
        delivery_truck_filter() {
            this.filterItems();
        },
        truck_assignment_filter() {
            this.filterItems();
        },
        delivery_status_filter() {
            this.filterItems();
        },
        selectedItems(newVal) {
            this.selectAll = newVal.length === this.displayItems.length && this.displayItems.length > 0;
            this.forceUpdateFlag = !this.forceUpdateFlag;
        },
        displayItems() {
            this.selectAll = this.selectedItems.length === this.displayItems.length && this.displayItems.length > 0;
        },
        items: {
            deep: true,
            handler(newItems) {
                newItems.forEach(item => {
                    if (!this.originalValues[item.itemid]) {
                        this.originalValues[item.itemid] = {
                            pickup_truck: item.pickup_truck,
                            truck: item.truck,
                            drop_locsub: item.drop_locsub,
                            locsub: item.locsub,
                            ship_locsub: item.ship_locsub
                        };
                    }
                });
                this.forceUpdateFlag = !this.forceUpdateFlag;
            }
        },
        delivery_location_filter() {
            this.filterItems();
        },
        location_filter() {
            this.filterItems();
        },
        drop_location_filter() {
            this.filterItems();
        },
        showSameLocationItems() {
            this.filterItems();
        },
    },
    
    mounted: function() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        this.initDatePicker();
        this.get_pick_items_for_date();
    },
    
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    
    created: function () {
        this.packet = JSON.parse(localStorage.packet);
        this.packet.userDetails = JSON.parse(localStorage.userDetails);
        this.packet.locsubsdict["-1|-1"] = "CUSTOMER HOME";
        
        const requiredStatuses = [0, 2, 3, 14, 15, 30, 11, 13];
        this.limitedStatesDict = {};
        
        mappings.states.forEach(state => {
            if (requiredStatuses.includes(state.value)) {
                this.limitedStatesDict[state.value] = state.text;
            }
        });
        
        this.fetch_prereqs();
    }
}
</script>

<style scoped>
.non-selectable {
    opacity: 0.6;
    background-color: #f5f5f5;
}
.ipt_tdr {
    font-family: roboto !important;
    font-size: 13px;
    background: white;
}

.pcol {
    padding: 5px;
}

.card-body {
    padding: 5px;
}

/* Truck status styles */
.truck-status-assigned {
    color: #28a745;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
}

.truck-status-not-assigned {
    color: #dc3545;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
}

.truck-status-delivered {
    color: #484f5c;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
}

.truck-status-picked {
    color: #ffae00;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
}

.truck-status-dropped {
    color: #17a2b8;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    display: inline-block;
}

/* Delivery status styles */
.delivery-status-delivered {
    color: #28a745;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #c3e6cb;
    display: inline-block;
}

.delivery-status-in-picked {
    color: #ffc107;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #ffeaa7;
    display: inline-block;
}

.delivery-status-dropped {
    color: #ffc107;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #ffeaa7;
    display: inline-block;
}

.delivery-status-dispatched {
    color: #07b0ff;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #ffeaa7;
    display: inline-block;
}

.delivery-status-assigned {
    color: #007bff;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #b8daff;
    display: inline-block;
}

.delivery-status-not-assigned {
    color: #fc4545;
    font-weight: bold;
    background-color: #ffffff;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    display: inline-block;
}

@media (max-width: 600px) {
    .responsive-input {
        width: 100% !important;
        display: block !important;
    }
    
    .filter-alert {
        margin-bottom: 5px !important;
        margin-right: 0 !important;
        width: 100% !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsProcessPickups.vue